export class EnvironmentConfig {
  type: EnvironmentType;
  ver: string;
  authBaseUrl: string;
  apiUrl: string;
  openApiUrl: string;
  notificationsUrl: string;
  notificationsAllUrl: string;
  disableForm: boolean;
  showAuthorizeLogs: boolean;
  showBuildTime: boolean;
  showEasterEggs: boolean;
  deepLinkScheme: string;
  azureAuthConfig: {
    b2cDirectory: string;
    stsBase: string;
    tenant: string;
    policyKey: string;
    stsServer: string;
    stsServerSignInEmail: string;
    stsServerSignInObjectId: string;
    stsServerSignIn: string;
    clientID: string;
    b2cScopes: string;
    redirectUrl: string;
    postLogoutRedirectUrl: string;
    forgotPasswordUrl: string;
  };
  sentryUrl?: string; // local and demo are not connected to Sentry
}

export enum EnvironmentType {
  Demo,
  Dev,
  Local,
  Prod,
  QA,
}
